export const MATCH_PLAYER_CARD_VIEWS = {
  FACEIT: "faceit",
  HYBRID: "hybrid",
  OURO: "ouro",
};

export const MATCH_PLAYER_CARD_VIEW_OPTIONS = [
  { value: MATCH_PLAYER_CARD_VIEWS.FACEIT, label: "LEGACY" },
  { value: MATCH_PLAYER_CARD_VIEWS.HYBRID, label: "HYBRID" },
  { value: MATCH_PLAYER_CARD_VIEWS.OURO, label: "OURO" },
];

export const DEFAULT_MATCH_PLAYER_CARD_VIEW = MATCH_PLAYER_CARD_VIEWS.HYBRID;

export const MATCH_PLAYER_CARD_VIEW_STORAGE_KEY =
  "ouro.matchPage.playerCardView";

function getBrowserStorage() {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const { localStorage } = window;
    if (!localStorage || typeof localStorage.getItem !== "function") {
      return null;
    }
    return localStorage;
  } catch {
    return null;
  }
}

export function isValidMatchPlayerCardView(value) {
  return (
    value === MATCH_PLAYER_CARD_VIEWS.FACEIT ||
    value === MATCH_PLAYER_CARD_VIEWS.HYBRID ||
    value === MATCH_PLAYER_CARD_VIEWS.OURO
  );
}

export function readMatchPlayerCardView(storage = getBrowserStorage()) {
  if (!storage || typeof storage.getItem !== "function") {
    return DEFAULT_MATCH_PLAYER_CARD_VIEW;
  }
  let raw;
  try {
    raw = storage.getItem(MATCH_PLAYER_CARD_VIEW_STORAGE_KEY);
  } catch {
    return DEFAULT_MATCH_PLAYER_CARD_VIEW;
  }
  if (raw == null || raw === "") {
    return DEFAULT_MATCH_PLAYER_CARD_VIEW;
  }
  if (!isValidMatchPlayerCardView(raw)) {
    return DEFAULT_MATCH_PLAYER_CARD_VIEW;
  }
  return raw;
}

export function writeMatchPlayerCardView(
  value,
  storage = getBrowserStorage()
) {
  const resolved = isValidMatchPlayerCardView(value)
    ? value
    : DEFAULT_MATCH_PLAYER_CARD_VIEW;
  if (!storage || typeof storage.setItem !== "function") {
    return resolved;
  }
  try {
    storage.setItem(MATCH_PLAYER_CARD_VIEW_STORAGE_KEY, resolved);
  } catch {
    // Storage may be unavailable or quota exceeded; keep UI stable.
  }
  return resolved;
}
